import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as appDataActions from '../../../../actions/appDataActions';
import * as trackingDataActions from '../../../../actions/trackingDataActions';
import * as dialogPopupActions from '../../../../actions/dialogPopupActions';
import * as appHelper from '../../../../helpers/appHelper';
import * as objectConstants from '../../../../constants/objectConstants';
import OptionAudioControls from "../../audio/OptionAudioController";
import * as animationHelper from "../../../../helpers/animationHelper";

class AudioAnswerOption extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            option: this.props.option,
            locale: appHelper.getLocalData(this.props.option),
            responseData: this.props.responseData,
            focusedOption: this.props.focusedOption,
            focusedClass:"not-focused",
        };

        this.removeOption = this.removeOption.bind(this);
        this.setOptionAsSelected = this.setOptionAsSelected.bind(this);
        this.onOptionHidden = this.onOptionHidden.bind(this);
        this.getDisabledState = this.getDisabledState.bind(this);
        this.getOptionClass = this.getOptionClass.bind(this);
        this.getClickFunction = this.getClickFunction.bind(this);
        this.onOptionRevealed= this.onOptionRevealed.bind(this);
        this.renderOption = this.renderOption.bind(this);
        this.getCheckedState = this.getCheckedState.bind(this);
        this.getIsChecked = this.getIsChecked.bind(this);
        this.getIsDisabled = this.getIsDisabled.bind(this);
        this.setFocus = this.setFocus.bind(this);
        this.setBlur = this.setBlur.bind(this);
		this.getScreenReaderOptionClass = this.getScreenReaderOptionClass.bind(this);

        this.objectRef = React.createRef();
	}

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {
        if (this.state.responseData !== nextProps.responseData) {
            this.setState({responseData: nextProps.responseData});
        }
        if (this.state.focusedOption !== nextProps.focusedOption) {
            this.setState({focusedOption: Object.assign({}, nextProps.focusedOption)});
        }

        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.option)
            });
        }
    }

    componentDidUpdate() {
    }

    getOptionClass() {
        let responseData = this.state.responseData;
        let latestResponse = appHelper.getLastItemOfArray(responseData.responses);
        if (this.props.questionChecked) {
            if(this.props.showOutcome  || this.state.option.result === objectConstants.SCORING_TYPE_REFLECTIVE) {
                if (responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
                    if ((responseData.currentAttempt === responseData.responses.length) && (latestResponse.selectedOption.option_id == this.state.option.option_id)) {

                        if (responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_ANSWERED) {
                            return `active ${this.state.option.result}`;
                        } else if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_ANSWERED && this.props.showFeedback) {
                            return `selected ${this.state.option.result}`;
                        } else if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_ANSWERED && !this.props.showFeedback) {
                            return `selected ${this.state.option.result}`;
                        }
                    } else {
                        for (let i = 0; i < this.state.responseData.responses.length; i++) {
                            let response = this.state.responseData.responses[i];
                            if (response.selectedOption.option_id === this.state.option.option_id) {
                                return `show-answer ${this.state.option.result}`;
                            }
                        }
                    }
                } else if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
                    if ((responseData.currentAttempt === responseData.responses.length) && (latestResponse.selectedOption.option_id == this.state.option.option_id) && this.props.showFeedback) {
                        return `selected answered ${this.state.option.result}`;
                    } else if ((responseData.currentAttempt === responseData.responses.length) && (latestResponse.selectedOption.option_id == this.state.option.option_id) && !this.props.showFeedback) {
                        return `selected inactive-answered ${this.state.option.result}`;
                    } else {
                        return `review ${this.state.option.result}`;
                    }

                }
            }else{
                return `selected assessment`;
            }
        }
        return "";
    }

	getScreenReaderOptionClass() {
		let responseData = this.state.responseData;
		let latestResponse = appHelper.getLastItemOfArray(responseData.responses);
		if (this.props.questionChecked) {
            if(this.props.showOutcome) {
                if (responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
                    if ((responseData.currentAttempt === responseData.responses.length) && (latestResponse.selectedOption.option_id == this.state.option.option_id)) {

                        if (responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_ANSWERED) {
                            return "";
                        } else if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_ANSWERED && this.props.showFeedback) {
                            return appHelper.getOptionResultString(this.state.option.result, false);
                        } else if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_ANSWERED && !this.props.showFeedback) {
                            return appHelper.getOptionResultString(this.state.option.result, false);
                        }
                    } else {
                        for (let i = 0; i < this.state.responseData.responses.length; i++) {
                            let response = this.state.responseData.responses[i];
                            if (response.selectedOption.option_id === this.state.option.option_id) {
                                return appHelper.getOptionResultString(this.state.option.result, true);
                            }
                        }
                    }
                } else if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
                    if ((responseData.currentAttempt === responseData.responses.length) && (latestResponse.selectedOption.option_id === this.state.option.option_id) && this.props.showFeedback) {
                        return appHelper.getOptionResultString(this.state.option.result, false);
                    } else if ((responseData.currentAttempt === responseData.responses.length) && (latestResponse.selectedOption.option_id === this.state.option.option_id) && !this.props.showFeedback) {
                        return appHelper.getOptionResultString(this.state.option.result, false);
                    } else {
                        return appHelper.getOptionResultString(this.state.option.result, false);
                    }

                }
            }
		}
		return "";
	}

    renderOption(){
        let responseData = this.state.responseData;
        let latestResponse = appHelper.getLastItemOfArray(responseData.responses);
        if (this.props.questionChecked && this.props.currentlyChecked) {
            if(latestResponse.selectedOption.option_id === this.state.option.option_id){
                return true;
            }else{
                return false;
            }
        }else{
            return true;
        }
    }

    getClickFunction() {
        let responseData = this.state.responseData;
        let latestResponse = appHelper.getLastItemOfArray(responseData.responses);
        if ((responseData.currentAttempt === responseData.responses.length) && (latestResponse.selectedOption.option_id == this.state.option.option_id) && this.props.showFeedback) {
            if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
                this.props.onReviewObject(`option_${this.state.option.option_id}`);
            }
        }
    }

    getDisabledState() {
        let responseData = this.state.responseData;
        //if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_INITIAL) {
        if (responseData.currentAttempt === responseData.responses.length && this.props.questionChecked) {
            return `disabled`;
        } else {
            for (let i = 0; i < this.state.responseData.responses.length; i++) {
                let response = this.state.responseData.responses[i];
                if (response.selectedOption.option_id === this.state.option.option_id && this.props.questionChecked) {
                    return `disabled`;
                }
            }
            return null;
        }
    }


    onOptionRevealed(){
        this.props.onOptionRevealed(this.props.option);
    }


    setOptionAsSelected() {
        let objectRef = this.objectRef.current;
        if (appHelper.isEleDefined(objectRef)) {

            let params = {
                ele: objectRef,
                duration: objectConstants.SHOW_PANEL_DURATION,
                delay: 0.5,
                className: '+=selected',
                callback: null,
                callbackParams: null
            };
            animationHelper.setClassName(params);

            /*TweenLite.to(objectRef, 0.5, {
                css: {className: '+=selected'},
                delay: 0.5
            });*/
        }
    }

    onOptionHidden() {
        let responseData = this.state.responseData;
        let latestResponse = appHelper.getLastItemOfArray(responseData.responses);

        //if selected option is first in the list
        if (latestResponse.index === 0) {
            this.removeOption();
        } else {
            this.scaleOptionHeight();
        }
    }

    removeOption() {
        //this.setState({render: false});
    }

    getCheckedState(){
        let responseData = this.state.responseData;
        let latestResponse = responseData.latestResponse;
        if (appHelper.isDefined(latestResponse.option_id) && latestResponse.option_id === this.state.option.option_id) {
            //console.log(`getCheckedState`, latestResponse);
            return `checked`;
        }
    }

    getIsChecked() {
        let responseData = this.state.responseData;
        let latestResponse = responseData.latestResponse;
        //console.log(`getCheckedState`,latestResponse);
        if(appHelper.isDefined(latestResponse.option_id) && latestResponse.option_id === this.state.option.option_id) {
            //console.log(`getCheckedState`, latestResponse);
            return true;
        }else{
            return false;
        }
    }

    getIsDisabled() {
        let responseData = this.state.responseData;
        //if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_INITIAL) {
        if (responseData.currentAttempt === responseData.responses.length || this.state.isAnimating) {
            return true;
        } else {
            for (let i = 0; i < this.state.responseData.responses.length; i++) {
                let response = this.state.responseData.responses[i];
                if (response.selectedOption.option_id === this.state.option.option_id) {
                    return true;
                }
            }
            return false;
        }
    }

    setFocus(){
        this.setState({focusedClass:"focused"});
    }
    setBlur(){
        this.setState({focusedClass:"not-focused"});
    }


    render() {

        return (
            this.renderOption()
            ?
                <div className="audio-option-container">
                    <div className="option-audio-controls">
                        <OptionAudioControls option={this.state.option} />
                    </div>
                    <div className={`audio-choice-option ${this.getOptionClass()} ${this.state.focusedClass}`}
                        ref={this.objectRef}
                         id={`option_${this.state.option.option_id}`}
                         onClick={this.getClickFunction}
                         onKeyDown={this.props.optionCallbacks.setKeyboardAccessibility}
                         onFocus={this.setFocus}
                         onBlur={this.setBlur}
                         role="radio"
                         tabIndex={this.state.focusedOption.option_id === this.state.option.option_id || this.getIsChecked() ? 0 : -1}
                         aria-checked={this.getIsChecked()}
                         aria-disabled={this.getIsDisabled()}>
                        <input id={`${this.props.asset_id}_${this.state.option.option_id}`} type="radio"
                               disabled={this.getDisabledState()}
                               name={`${this.props.asset_id}_${this.state.option.option_id}`}
                               checked={this.getCheckedState()}
                               value={this.state.option.option_id} onChange={this.props.onOptionClick}/>
                        <label htmlFor={`${this.props.asset_id}_${this.state.option.option_id}`}>
                           <span dangerouslySetInnerHTML={{__html: this.state.locale.option}}/>
                            <span className="hidden-el">{this.getScreenReaderOptionClass()}</span>
                        </label>

                    </div>
                </div>
            :
                null

        );

    }
}

AudioAnswerOption.propTypes = {
    option: PropTypes.object.isRequired,
    asset_id: PropTypes.number.isRequired,
    questionChecked: PropTypes.bool.isRequired,
    currentlyChecked: PropTypes.bool.isRequired,
    responseData: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
    onOptionClick: PropTypes.func,
    onAttemptComplete: PropTypes.func,
    onReviewObject: PropTypes.func,
    onOptionRevealed: PropTypes.func,
    focusedOption: PropTypes.object,
    showFeedback: PropTypes.bool,
    contentData: PropTypes.object,
    trackingData: PropTypes.object,
    optionCallbacks: PropTypes.object,
    showOutcome: PropTypes.bool,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object
};

AudioAnswerOption.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        contentData: state.contentData,
        trackingData: state.trackingData,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AudioAnswerOption);



/** WEBPACK FOOTER **
 ** ./src/components/objects/multipleChoice/singleAnswer/AudioAnswerOption.js
 **/